import * as R from "ramda"
// @ts-expect-error: Flow to TS migration.
import { createSelector, OutputSelector, InputSelector } from "reselect"
import { INSURANCE_NAMES } from "@kiwicom/frontend-common/consts/insurance"
import type { Insurance } from "@kiwicom/frontend-common/components/CommonInsurance/services/utils"
import type { PassengerId } from "@kiwicom/frontend-common/types/primitiveTypes"
import Price from "@kiwicom/frontend-common/records/Price"
import {
  ancillariesSelector,
  bookingDataSelector,
} from "@kiwicom/frontend-common/services/booking/booking"

import { bookingPassengersSelector } from "../../../../../services/selector"
import type {
  AxaUsInsuranceAncillaries,
  AxaUsInsuranceAncillariesPassenger,
} from "../../../../BookingAncillary/consts/types"
import { usPassengerSelector } from "./bookingInsuranceSelectors"
import { SERVICES_STATUSES } from "../../../../../../../../../consts/additionalServices"
import type { UsInsuranceData } from "../types"

export const axaUsInsurancesSelector: InputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  AxaUsInsuranceAncillaries | null | undefined
> = createSelector(ancillariesSelector, R.prop("axaUsInsurance"))

export const axaUsActivePaxInsurancesSelector: InputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  AxaUsInsuranceAncillariesPassenger[]
> = createSelector(axaUsInsurancesSelector, (axaUsInsurances) => {
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/array-type, @typescript-eslint/no-explicit-any
  const allPaxAxaUsInsurances = (axaUsInsurances || []).reduce<Array<any>>(
    // @ts-expect-error: Flow to TS migration.
    (acc, axaUsInsurance) => acc.concat(...axaUsInsurance?.items),
    [],
  )

  return allPaxAxaUsInsurances.filter(
    // @ts-expect-error: Flow to TS migration.
    (papInsurance) => papInsurance.isActive && papInsurance.level === "plus",
  )
})

export const axaUsInsurancePassengersTypeSelector: InputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Partial<Record<PassengerId, Insurance | null | undefined>> | null
> = createSelector(
  bookingPassengersSelector,
  axaUsActivePaxInsurancesSelector,
  (passengers, axaUsPaxActiveInsurances) =>
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    passengers.reduce<Record<string, any>>((acc, pap) => {
      if (pap.nationality !== "us") {
        acc[pap.id] = undefined
        return acc
      }

      const isPapInsuranceActive = Boolean(
        // @ts-expect-error: Flow to TS migration.
        axaUsPaxActiveInsurances.find((papInsurance) => papInsurance.id === pap.id),
      )

      if (!isPapInsuranceActive) {
        acc[pap.id] = INSURANCE_NAMES.US_NONE
        return acc
      }

      acc[pap.id] = INSURANCE_NAMES.AXA_US
      return acc
    }, {}),
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const axaUsInsuranceDataSelector: OutputSelector<any, any, UsInsuranceData> = createSelector(
  bookingDataSelector,
  usPassengerSelector,
  axaUsInsurancesSelector,
  axaUsActivePaxInsurancesSelector,
  (bookingData, usPassengers, axaUsInsurances, axaUsActivePaxInsurances) => {
    // Atm Axa Us can not be bought while booking
    const axaUsInsuranceBoughtOnBooking =
      // Fix this the next time the file is edited. (Flow to TS)
      // @ts-expect-error: Flow to TS migration.
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      axaUsInsurances && axaUsInsurances.find((axaUsInsurance) => axaUsInsurance.extraId === null)

    // @ts-expect-error: Flow to TS migration.
    const axaUsService = bookingData.additionalServices.find(
      // @ts-expect-error: Flow to TS migration.
      ({ backendCategory }) => backendCategory === "axa_us_insurance",
    )
    return {
      refundExpiryDate: axaUsInsuranceBoughtOnBooking?.refundableUntil || "",
      // @ts-expect-error: Flow to TS migration.
      totalPrice: Price.sum(axaUsActivePaxInsurances.map((insurance) => insurance.price)),
      // @ts-expect-error: Flow to TS migration.
      anyPaxWithInsurance: axaUsActivePaxInsurances.length > 0,
      pendingRefund: axaUsService && axaUsService.status === SERVICES_STATUSES.PENDING,
      // @ts-expect-error: Flow to TS migration.
      passengers: usPassengers.map((papData) => ({
        // @ts-expect-error: Flow to TS migration.
        insurance: axaUsActivePaxInsurances.find((papInsurance) => papInsurance.id === papData.id),
        passenger: papData,
      })),
      isAxaUs: true,
    }
  },
)
